import qs from 'qs'

import { HttpService, HttpServiceResponse } from '../shared'
import { UtilityPages, UnicodeToLatinServerData, CollateralManagementServerData } from './utility.types'

export class UtilityProvider {
  private get url(): string {
    return `${this.baseUrl}/util_api.php`
  }

  constructor(private http: HttpService, private baseUrl: string) {}

  public unicodeToLatin(unicodeText: string): Promise<HttpServiceResponse<UnicodeToLatinServerData>> {
    const queryString = qs.stringify({
      page: UtilityPages.UnicodeToLatin,
      Text: unicodeText,
    })

    return this.http.post(`${this.url}?${queryString}`)
  }

  public getCollateralManagementSession(): Promise<HttpServiceResponse<CollateralManagementServerData>> {
    return this.http.post(`${this.url}?page=${UtilityPages.CollateralManagementSession}`)
  }
}
